/*global _ */
import {coerceBoolean} from '../../lib/utils'
export default {
  computed: {
    timerExpiredMessages() {
      const showFirstItem = coerceBoolean(this.$$s('timer.expired.popup.showFirstItem', true))
      const showNew = coerceBoolean(this.$$s('timer.expired.popup.buttons.new.show', false))
      const showEdit = coerceBoolean(this.$$s('timer.expired.popup.buttons.edit.show', true))
      const showDelete = coerceBoolean(this.$$s('timer.expired.popup.buttons.delete.show', true))
      const autoRemoveItem = coerceBoolean(this.$$s('timer.expired.items.autoRemove', false))
      const cartItems = this.getTimeoutRemovedItems() || []
      const firstItem = _.head(cartItems)
      const count = cartItems.length
      const firstItemName = showFirstItem && firstItem && firstItem.itemTypeTitle || ''
      const messages = [`Sorry, the time to hold your ${firstItemName} reservation selections has expired.`]
      if (count && autoRemoveItem) {
        messages.push(` Your reservation ${count > 1 ? 'items have': 'item has'} been removed from the cart.`)
      }
      if (!count) {
        messages.push(` You need to start over again.`)
      }

      const deleteFactory = (item) => {
        return (...args) => {
          item.unsetTimeoutRemovedItem(item)
          item.itemDelete(...args)
          item.showTimeoutAlert(false)
          if (showFirstItem) {
            this.$nextTick(() => {
              const cartItems = this.getTimeoutRemovedItems()
              if (cartItems.length) {
                item.showTimeoutAlert()
              }
            })
          }
        }
      }

      const item = (showFirstItem && firstItem) ? {
        showNew,
        showEdit,
        showDelete,
        name: firstItem.itemTypeTitle,
        route: _.get(firstItem, 'item.editRoute.name', firstItem.itemTypeTitle),
        edit: (...args) => firstItem.itemEdit(...args),
        delete: deleteFactory(firstItem),
      } : null

      const items = (!showFirstItem && count > 1) ? cartItems.map((item) => {
        return {
          showNew,
          showEdit,
          showDelete,
          name: item.itemTypeTitle,
          route: _.get(item, 'item.editRoute.name', item.itemTypeTitle),
          edit: (...args) => item.itemEdit(...args),
          delete: deleteFactory(item),
        }
      }) : []

      return {
        topMessage: messages.join(''),
        item,
        items
      }
    }
  }
}
